import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LottieInfoDialogModel } from './lottie-info-dialog.model';
import { LottieComponent } from 'ngx-lottie';
import { TranslocoModule } from '@jsverse/transloco';
import { BaseDialogComponent } from '@futura/futura-ui/dialog';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-lotti-info-dialog',
  templateUrl: './lottie-info-dialog.component.html',
  styleUrls: ['./lottie-info-dialog.component.scss'],
  standalone: true,
  imports: [LottieComponent, TranslocoModule, BaseDialogComponent],
})
export class LottieInfoDialogComponent {
  private readonly dialogData = inject<LottieInfoDialogModel>(MAT_DIALOG_DATA, { optional: true });
  private readonly bottomSheetData = inject<LottieInfoDialogModel>(MAT_BOTTOM_SHEET_DATA, { optional: true });
  protected readonly infoTitle = signal<string | undefined>(undefined);
  protected readonly infoSubTitle = signal<string | undefined>(undefined);
  protected readonly lottiePath = signal<string | undefined>(undefined);

  constructor() {
    const data = this.dialogData || this.bottomSheetData;
    if (data) {
      const { infoTitle, infoSubTitle, lottiePath } = data;
      this.infoTitle.set(infoTitle);
      this.infoSubTitle.set(infoSubTitle);
      this.lottiePath.set(lottiePath);
    }
  }
}
